import { type CoreDslFormLeafPartial, getOrderedComparison } from '@salescore/core'
import { SortableListWrapper } from '@salescore/frontend-common'
import { Button, Dropdown, Form } from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export const CoreDslFormExtraFormItem = ({
  leaf,
  onChange,
}: {
  onChange: (x: CoreDslFormLeafPartial['extra']) => void
  leaf: CoreDslFormLeafPartial
}): ReactNode => {
  const { t } = useTranslation()
  const orderedComparison = getOrderedComparison(leaf)
  if (orderedComparison === undefined) {
    return <></>
  }

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: [
          {
            key: '',
            label: (
              <div
                onClick={(event) => {
                  event.preventDefault()
                  event.stopPropagation()
                }}
              >
                <SortableListWrapper
                  items={orderedComparison.options.map((option) => ({
                    ...option,
                    key: option.value,
                    disableDrag: false,
                  }))}
                  onChange={(values) => {
                    onChange({
                      sortedValues: values.map((x) => x.value),
                    })
                  }}
                  options={{
                    deletable: false,
                    bordered: false,
                  }}
                />
              </div>
            ),
          },
        ],
      }}
    >
      <Form.Item label={t('順序設定')}>
        <Button>{t('順序設定')}</Button>
      </Form.Item>
    </Dropdown>
  )
}
